import "./slashy.less";